module.exports = __webpack_public_path__ + "static/images/movie-place-bg.292ab3b.jpg";